import { useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Icon } from 'web-library';
import { FUNCTION_NAMES } from 'web-library/models/AuthorityFunctions';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useGetUserGrantedAccess } from '../../../../api-refactored/user/useGetUserGrantedAccess';
import { AccessOption } from '../../../../models';

interface INonNationalExamGroupsButtonProps {
  classes: any;
  onOpenDialogExport: () => void;
  onOpenDialogImport: () => void;
}

const NonNationalExamGroupsButton = ({
  classes,
  onOpenDialogExport,
  onOpenDialogImport,
}: INonNationalExamGroupsButtonProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { data } = useGetUserGrantedAccess({
    functionName: FUNCTION_NAMES.NON_NATIONAL_RESULTS_RELEASE,
  });
  const hasImportPermission = !!data && data.VIEW?.includes(AccessOption.IMPORT);
  const hasExportPermission = !!data && data.VIEW?.includes(AccessOption.EXPORT);

  return (
    <Box>
      {hasExportPermission && (
        <Button
          id="button-candidateBlacklist-export"
          variant="text"
          color="primary"
          startIcon={<Icon name={IconName.export} size="S" color={theme.color.icon.iconSelected} />}
          className={classes.addCandidateButton}
          onClick={onOpenDialogExport}
        >
          {t('admin->>ResultRelease.ExportResults')}
        </Button>
      )}
      {hasImportPermission && (
        <Button
          id="button-candidateBlacklist-import"
          variant="text"
          color="primary"
          startIcon={
            <Icon name={IconName.download} size="S" color={theme.color.icon.iconSelected} />
          }
          className={classes.addCandidateButton}
          onClick={onOpenDialogImport}
        >
          {t('admin->>ResultRelease.ImportResults')}
        </Button>
      )}
    </Box>
  );
};

export default NonNationalExamGroupsButton;
